import React from 'react';
import { MaintenanceTaskRaw } from '../types';

const TaskEntry = ({ title, value }: { title: string; value: string }) => {
  return (
    <div className="font-medium">
      <div className="text-xs text-[rgba(85,104,125,1)]">
        {title}
      </div>
      <div className="text-sm">{value || '–'}</div>
    </div>
  );
};

interface TaskDetailsProps {
  details: MaintenanceTaskRaw;
}

export const TaskDetails = ({ details }: TaskDetailsProps) => {
  return (
    <div className="w-full flex flex-col items-start gap-4">
      <TaskEntry title="" value={details.description} />
    </div>
  );
};
